export default class Constants {
    static readonly tokenStorageName = 'GameOrganiser_Token';
    static readonly webApiBaseUrl = 'https://localhost:7291';
    static readonly discordCdnBaseUrl = 'https://cdn.discordapp.com/';
    static readonly igdbImageCdn = 'https://images.igdb.com/';
}
